import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiUrl } from 'src/app/models/ApiUrl';
import { HttpService } from 'src/app/services/http/http.service';

@Injectable()
export class ProductReportService {
  private httpService = inject(HttpService);
  constructor() {}

  public getProductList() {
    return this.httpService.get(ApiUrl.PRODUCT_LIST)
    .pipe(
      map((data: any) => {
        return data.Data;
      })
    );
  }
}
